import React from 'react';
import { Users, Award, Phone, MapPin } from 'lucide-react';
import { Card } from './ui/card';

const QuiNousSommes = ({ theme = 'light' }) => {
  const isDark = theme === 'dark';
  
  return (
    <section className={`py-6 md:py-10 ${isDark ? 'bg-gray-900' : 'bg-gradient-to-b from-gray-50 to-white'}`}>
      <div className="container mx-auto px-4">
        <div className="max-w-5xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12">
            <div className={`inline-flex items-center space-x-2 ${isDark ? 'bg-red-900/30 border-red-500/30 text-white' : 'bg-cyan-100 text-cyan-700'} rounded-full px-4 py-2 mb-6 border`}>
              <Users size={18} />
              <span className="text-sm font-semibold">À propos</span>
            </div>
            <h2 className={`text-3xl md:text-4xl font-bold mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`}>
              Qui sommes-nous?
            </h2>
            <div className={`w-24 h-1 mx-auto ${isDark ? 'bg-gradient-to-r from-red-600 to-red-500' : 'bg-gradient-to-r from-cyan-500 to-blue-600'} rounded-full`}></div>
          </div>

          {/* Content Grid */}
          <div className="grid md:grid-cols-2 gap-8 items-center">
            {/* Left - Image */}
            <div className="relative">
              <Card className={`overflow-hidden ${isDark ? 'border-red-500/20 bg-gray-800' : 'border-0'} shadow-2xl`}>
                <img
                  src="/team-photo.jpg"
                  alt="Équipe Groupe Lavage Fenêtres"
                  className="w-full h-80 object-cover object-[50%_25%]"
                />
                <div className={`absolute inset-0 ${isDark ? 'bg-gradient-to-t from-black/80' : 'bg-gradient-to-t from-black/60'} to-transparent`}></div>
                <div className="absolute bottom-6 left-6 right-6">
                  <div className={`${isDark ? 'bg-red-600' : 'bg-cyan-600'} text-white px-6 py-3 rounded-lg inline-block shadow-xl`}>
                    <p className="text-2xl font-bold">5 ans</p>
                    <p className="text-sm">d'expérience</p>
                  </div>
                </div>
              </Card>
            </div>

            {/* Right - Text Content */}
            <div className="space-y-6">
              <p className={`text-lg leading-relaxed ${isDark ? 'text-gray-300' : 'text-gray-700'}`}>
                <strong className={isDark ? 'text-white' : 'text-gray-900'}>Groupe Lavage Fenêtres</strong> est une entreprise{' '}
                <span className={isDark ? 'text-red-400' : 'text-cyan-600'}>jeune et dynamique</span> de la région de Centre du Québec, 
                spécialisée dans le lavage résidentiel et le scellant d'asphalte.
              </p>
              
              <p className={`text-lg leading-relaxed ${isDark ? 'text-gray-300' : 'text-gray-700'}`}>
                Notre équipe combine <strong className={isDark ? 'text-white' : 'text-gray-900'}>énergie et professionnalisme</strong> pour 
                offrir un service de qualité supérieure. Nous utilisons des équipements modernes et des techniques éprouvées 
                pour garantir votre satisfaction.
              </p>

              {/* Features */}
              <div className="grid grid-cols-2 gap-4 pt-4">
                <div className="flex items-start space-x-3">
                  <Award className={`${isDark ? 'text-red-500' : 'text-cyan-600'} flex-shrink-0 mt-1`} size={24} />
                  <div>
                    <h4 className={`font-semibold ${isDark ? 'text-white' : 'text-gray-900'}`}>Minutieux</h4>
                    <p className={`text-sm ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>Souci du détail</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <Users className={`${isDark ? 'text-red-500' : 'text-cyan-600'} flex-shrink-0 mt-1`} size={24} />
                  <div>
                    <h4 className={`font-semibold ${isDark ? 'text-white' : 'text-gray-900'}`}>Professionnel</h4>
                    <p className={`text-sm ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>Équipe qualifiée</p>
                  </div>
                </div>
              </div>

              {/* Contact Info */}
              <div className={`${isDark ? 'bg-gray-800 border-red-500/20' : 'bg-white border-gray-200'} border rounded-xl p-6 space-y-3 shadow-lg mt-6`}>
                <div className="flex items-center space-x-3">
                  <Phone className={`${isDark ? 'text-red-500' : 'text-cyan-600'}`} size={20} />
                  <div>
                    <p className={`text-sm ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>Appelez-nous</p>
                    <p className={`font-bold text-lg ${isDark ? 'text-white' : 'text-gray-900'}`}>819.200.2015</p>
                  </div>
                </div>
                <div className="flex items-center space-x-3">
                  <MapPin className={`${isDark ? 'text-red-500' : 'text-cyan-600'}`} size={20} />
                  <div>
                    <p className={`text-sm ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>Zone de service</p>
                    <p className={`font-semibold ${isDark ? 'text-white' : 'text-gray-900'}`}>Centre du Québec</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default QuiNousSommes;
